module.exports = __webpack_public_path__ + "img/companyrightone.80c5c875.png";